import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { DownloadOutlined } from '@ant-design/icons';
import '@ant-design/compatible/assets/index.css';
import { Col, Button, Input } from 'antd';
import { assetsRestCrudThunksForBuyer, downloadAssetCSVForBuyer } from '../../thunks/assets_thunks';
import { EmptyState } from '../empty_state/EmptyState';
import { ASSETS_CRUD_ACTION_CREATORS } from '../../actions/assets_actions';
import {
	nullSafeGet,
	changeFilterValueToArrayOfIds,
	getStartDateFieldName,
	getEndDateFieldName,
	nullSafeGetOrElse,
	getTimeZoneFieldName,
} from '../../utils/DataAccessUtils';
import { locationsRestCrudThunksForBuyer } from '../../thunks/locations_thunks';
import { assetTypesRestCrudThunksForBuyer } from '../../thunks/asset_types_thunks';
import RegionsLocationsTreeSelect from '../regions_tree_select/RegionsLocationsTreeSelect';
import OWAsyncTreeSelect from '../ow_async_tree_select/OWAsyncTreeSelect';
import { PAGE_SIZE_OPTIONS } from '../../constants/pagination';
import OWRadioGroup from '../ow_radio_group/OWRadioGroup';
import {
	defaultTimeZone,
	FILTER_CONFIG_NAMES,
	FILTER_FIELD_TYPE,
	ROLE_TYPES,
} from '../../utils/DataConstants';
import OWDateRangePicker from '../ow_date_range_picker/OWDateRangePicker';
import moment from 'moment';
import {
	decodeUTCAdjustedDate,
	encodeUTCAdjustedDate,
	formatDateForParam,
} from '../../utils/DataFormatterUtils';
import AssetWithQRCodeDisplay from '../asset_row_display/AssetWithQRCodeDisplay';
import { getBuyerCompanySettingValue, PERMISSION_NAMES } from '../../utils/AuthUtils';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { getIsActiveFilterField, INITIAL_ACTIVE_FILTERS } from '../../utils/FilterUtils';
import ReduxDataTable from '../redux_data_table/ReduxDataTable';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import { areasRestCrudThunksForBuyer, fetchAreasWithHeirarchy } from '../../thunks/areas_thunks';
import OWButtonWithSupplierManagedLock from '../common/OWButtonWithSupplierManagedLock';
import ProblemTypeTreeSelect from '../problem_type_tree_select';
import { filterValueAccessorDateTime, handleChangeDateTime } from '../../hooks/workOrderHooks';

const queryString = require('qs');

require('./AssetsIndexPage.less');

const ASSETS_OVERVIEW_TARGET_COLLECTION = 'assetsIndex';

class AssetsIndexPage extends React.Component<any, any> {
	initialPagination: any = { current: 1, pageSize: 10 };
	initialFilters: any = {};
	preAppliedFilters: any = {};

	constructor(props) {
		super(props);
		const { updateAssetsFilters, location, history } = props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		const {
			current,
			pageSize,
			total,
			pageSizeOptions,
			showSizeChanger,
			onShowSizeChange,
			sort_by,
			order,
			...assetFilters
		} = queryParams;
		this.initialPagination = { current: current ? current : 1, pageSize: pageSize ? pageSize : 10 };
		this.initialFilters = assetFilters || {};
		updateAssetsFilters(this.initialFilters, ASSETS_OVERVIEW_TARGET_COLLECTION);
		history.push(`/buyer/assets/overview/all?${new URLSearchParams(location.search)}`);
	}

	downloadCSV = () => {
		const { assets, downloadAssetCSV } = this.props;
		const filters = assets[ASSETS_OVERVIEW_TARGET_COLLECTION].filters;
		downloadAssetCSV({}, filters);
	};

	render() {
		const {
			history,
			location,
			assets,
			fetchLocations,
			fetchMultipleLocations,
			locations,
			fetchAssetTypes,
			fetchMultipleAssetTypes,
			assetTypes,
			updateAssetsFilters,
			areas,
			fetchAreas,
			fetchMultipleAreas,
			companyConfig,
		} = this.props;

		const onRow = (record) => ({
			onClick: () => {
				const path = `/buyer/assets/detail/${nullSafeGet(
					'id',
					record
				)}/details?targetCollectionName=${ASSETS_OVERVIEW_TARGET_COLLECTION}`;
				history.push(
					getLinkWIthBackLinkParams(location, 'Back to Assets', path, {
						preserve: true,
					})
				);
			},
		});

		const columns = [
			{
				title: 'Name',
				dataIndex: 'name',
				render: (text, record) => <AssetWithQRCodeDisplay asset={record} />,
			},
		];

		const allowArea = getBuyerCompanySettingValue(ROLE_TYPES.BUYER)(
			'assetConfig.allowAreaAssociationWithAssets',
			companyConfig,
			{},
			false
		);

		const filterConfig = [
			{
				label: 'Location',
				mode: 'multiple',
				fieldName: 'locationIds',
				stateSlice: locations,
				filtersValueAccessor: (filtersStateSlice) => {
					const ids = nullSafeGet(
						`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters.locationIds`,
						filtersStateSlice
					);
					return changeFilterValueToArrayOfIds(ids);
				},
				keyAccessor: (loc) => loc.id,
				valueAccessor: (loc) => loc.id,
				handleChange: (ids) => {
					updateAssetsFilters(
						{
							locationIds: ids.join(',') || undefined,
						},
						ASSETS_OVERVIEW_TARGET_COLLECTION
					);
				},
				targetCollectionName: 'assetsAdvancedFilters',
				fetch: fetchLocations,
				fetchMultiple: fetchMultipleLocations,
				renderItem: (loc) => loc.name,
				sortBy: { sort_by: 'name', order: 'ascend' },
				component: RegionsLocationsTreeSelect,
			},
			...(allowArea
				? [
						{
							label: 'Area',
							mode: 'multiple',
							fieldName: 'areaIdsOrNull',
							stateSlice: areas,
							filtersValueAccessor: (filtersStateSlice) => {
								const ids = nullSafeGet(
									`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters.areaIdsOrNull`,
									filtersStateSlice
								);
								return changeFilterValueToArrayOfIds(ids);
							},
							keyAccessor: (area) => area.id,
							valueAccessor: (area) => area.id,
							handleChange: (ids) => {
								updateAssetsFilters(
									{
										areaIdsOrNull: ids.join(',') || undefined,
									},
									ASSETS_OVERVIEW_TARGET_COLLECTION
								);
							},
							targetCollectionName: 'assetsAdvancedFilters',
							fetch: fetchAreas,
							fetchMultiple: fetchMultipleAreas,
							renderItem: (area) => area.name,
							sortBy: { sort_by: 'name', order: 'ascend' },
							component: ProblemTypeTreeSelect,
						},
				  ]
				: []),
			{
				label: 'Asset Type',
				fieldName: FILTER_CONFIG_NAMES.ASSET_TYPE,
				mode: 'multiple',
				stateSlice: assetTypes,
				filtersValueAccessor: (filtersStateSlice) => {
					const ids = nullSafeGet(
						`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters.assetTypeIds`,
						filtersStateSlice
					);
					return changeFilterValueToArrayOfIds(ids);
				},
				keyAccessor: (assetType) => assetType.id,
				valueAccessor: (assetType) => assetType.id,
				handleChange: (ids) => {
					updateAssetsFilters(
						{
							assetTypeIds: ids.join(',') || undefined,
						},
						ASSETS_OVERVIEW_TARGET_COLLECTION
					);
				},
				targetCollectionName: 'assetsAdvancedFilters',
				fetch: fetchAssetTypes,
				fetchMultiple: fetchMultipleAssetTypes,
				renderItem: (assetType) => assetType.name,
				sortBy: { sort_by: 'name', order: 'ascend' },
				component: OWAsyncTreeSelect,
			},
			{
				component: Input,
				placeholder: 'Search for a manufacturer',
				handleChange: (e) => {
					updateAssetsFilters(
						{
							manufacturer: e.target.value || undefined,
						},
						ASSETS_OVERVIEW_TARGET_COLLECTION
					);
				},
				label: 'Manufacturer',
				fieldName: 'manufacturer',
				type: FILTER_FIELD_TYPE.SEARCH,
				filtersValueAccessor: (filtersStateSlice) =>
					nullSafeGet(`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters.manufacturer`, assets),
				renderItem: (loc) => loc,
				valueAccessor: (loc) => loc,
			},
			{
				fieldName: 'downtimeStatus',
				type: 'radioGroup',
				items: [
					{
						label: 'All',
						value: undefined,
					},
					{
						label: 'Online',
						value: 'online',
					},
					{
						label: 'Offline',
						value: 'offline',
					},
				],
				filtersValueAccessor: (filtersStateSlice) =>
					nullSafeGet(
						`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters.downtimeStatus`,
						filtersStateSlice
					),
				keyAccessor: (item) => item.value,
				valueAccessor: (item) => item.value,
				handleChange: (downtimeStatus) =>
					updateAssetsFilters({ downtimeStatus }, ASSETS_OVERVIEW_TARGET_COLLECTION),
				renderRecord: (item) => item.label,
				component: OWRadioGroup,
				info: [
					{
						title: 'Online',
						description: 'Asset is working and in good condition.',
					},
					{
						title: 'Offline',
						description: 'Asset is not working at this moment.',
					},
				],
			},
			...[getIsActiveFilterField(updateAssetsFilters, ASSETS_OVERVIEW_TARGET_COLLECTION, true)],
			{
				label: 'Installed Between',
				labelPrefix: 'Installed',
				fieldName: FILTER_CONFIG_NAMES.INSTALL_AT,
				type: FILTER_FIELD_TYPE.DATE_RANGE,
				renderRecord: (item) => item,
				valueAccessor: (item) => item,
				component: OWDateRangePicker,
				showTimeZone: true,
				additionalDefaultValues: [
					{
						[getTimeZoneFieldName(FILTER_CONFIG_NAMES.INSTALL_AT)]: undefined,
					},
				],
			},
			{
				fieldName: 'hasWarranty',
				type: 'radioGroup',
				items: [
					{
						label: 'All',
						value: 'undefined',
					},
					{
						label: 'Under Warranty',
						value: 'true',
					},
				],
				filtersValueAccessor: (filtersStateSlice) => {
					const filters = nullSafeGet(
						`${ASSETS_OVERVIEW_TARGET_COLLECTION}.filters`,
						filtersStateSlice
					);
					return typeof filters.hasWarranty === 'undefined'
						? 'undefined'
						: `${filters.hasWarranty}`;
				},
				defaultValue: undefined,
				keyAccessor: (item) => item.value,
				valueAccessor: (item) => item.value,
				handleChange: (hasWarranty) => {
					const val = hasWarranty === 'undefined' ? undefined : true;
					updateAssetsFilters({ hasWarranty: val }, ASSETS_OVERVIEW_TARGET_COLLECTION);
				},
				renderRecord: (item) => item.label,
				component: OWRadioGroup,
				info: [
					{
						title: 'Under Warranty',
						description: `Assets that are under warranty`,
					},
				],
			},
		];

		return (
			<ReduxDataTable
				rightActions={
					<Col style={{ textAlign: 'right' }}>
						<AccessPermissionChecker name={PERMISSION_NAMES.SHOW_ASSET_PRICE}>
							<OWButtonWithSupplierManagedLock
								style={{ marginRight: 12 }}
								size="large"
								icon={<DownloadOutlined />}
								className="inline-block-visible-md"
								onClick={this.downloadCSV}
							>
								<span className="inline-block-visible-xxl">Export CSV</span>
							</OWButtonWithSupplierManagedLock>
						</AccessPermissionChecker>
						<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_ASSETS}>
							<OWButtonWithSupplierManagedLock
								size="large"
								type="primary"
								onClick={() => this.props.history.push('/buyer/assets/overview/new')}
							>
								Add Asset
							</OWButtonWithSupplierManagedLock>
						</AccessPermissionChecker>
					</Col>
				}
				handleQueryParams
				filterConfig={filterConfig}
				emptyState={
					<EmptyState
						graphic={
							<img
								alt="Currently there are no assets!"
								style={{ marginBottom: 8 }}
								src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
							/>
						}
						headline={"It's a little lonely in here."}
						body={
							<div style={{ textAlign: 'center' }}>
								<div style={{ maxWidth: 440, marginBottom: 16 }}>
									Looks like your team has not added any assets yet.
								</div>
								<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_ASSETS}>
									<OWButtonWithSupplierManagedLock
										type="primary"
										onClick={() => this.props.history.push('/buyer/assets/overview/new')}
									>
										Add your first asset
									</OWButtonWithSupplierManagedLock>
								</AccessPermissionChecker>
							</div>
						}
					/>
				}
				collectionName="assets"
				onTableRow={onRow}
				showHeader={false}
				targetCollectionName="assetsIndex"
				tableColumns={columns}
				keyAccessor={(el) => el.id}
				initialFilters={{ ...this.initialFilters, ...INITIAL_ACTIVE_FILTERS }}
				initialPagination={this.initialPagination}
				hiddenPagination={{ showSizeChanger: true, pageSizeOptions: PAGE_SIZE_OPTIONS }}
				fetchData={assetsRestCrudThunksForBuyer}
				stateSlice={assets}
				entityCollectionName="assets"
				initialSorting={{ sort_by: 'name', order: 'ascend' }}
				preAppliedFilters={{ noActiveFilter: true }}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	assets: state.assets,
	assetTypes: state.asset_types,
	areas: state.areas,
	locations: state.locations,
	companyConfig: state.company_config.detail,
});

const mapDispatchToProps = (dispatch) => ({
	updateAssetsFilters: (filters, targetCollection) =>
		dispatch(ASSETS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)),
	clearAndUpdateFilters: (filters, targetCollectionName) =>
		dispatch(ASSETS_CRUD_ACTION_CREATORS.clearAndUpdateFilters(filters, targetCollectionName)),
	fetchMultipleAssetTypes: (ids, targetCollectionName) =>
		dispatch(assetTypesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchAssetTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			assetTypesRestCrudThunksForBuyer.readLite(
				{ ...params, no_pagination: true },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleLocations: (ids, targetCollectionName) =>
		dispatch(locationsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchLocations: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			locationsRestCrudThunksForBuyer.readLite(
				{ ...params, no_pagination: true },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchAreas: (params, targetCollectionName, pagination, sorting, filters, addToTargetCollection) =>
		dispatch(
			fetchAreasWithHeirarchy(ROLE_TYPES.BUYER)(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleAreas: (ids, targetCollectionName) =>
		dispatch(areasRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	downloadAssetCSV: (params, filters) => dispatch(downloadAssetCSVForBuyer(params, filters)),
});

export default withRouter<any, any>(connect(mapStateToProps, mapDispatchToProps)(AssetsIndexPage));
